<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'inventory.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Inventory <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>

                                <form-select label="Succursale" multiple="false" v-model="resource.branch" :default="resource.branch_id"  :options="branches" v-if="branches"></form-select>

                                <group-line-2>
                                  <form-text label="Name" v-model="resource.name" :required="true"></form-text>
                                  <form-text label="Reference / N° lot" v-model="resource.internal_identifier" :required="true"></form-text>
                                </group-line-2>

                                <form-text label="Quantité" v-model="resource.quantity" suffix="unité(s)"></form-text>

                              </fieldset>

                              <fieldset>
                                <h3>Produits</h3>
                                <p class="headline"></p>

                                <group-line-2>
                                  <form-datex label="Production date" v-model="resource.production_date" :hide-time="true" time="00:00:00"></form-datex>
                                  <form-datex label="Expiration date" v-model="resource.expiration_date" :hide-time="true" time="23:59:59"></form-datex>
                                </group-line-2>

                                <form-autocomplete label="Produits" v-model="product" :default="product" :service="productService" :callback="addProductToInventory"></form-autocomplete>

                                <div class="form-field form-products" v-if="resource.products && resource.products.length">
                                  <div class="form-label">Produits liés</div>
                                  <div class="form-input">
                                    <div v-for="(product,index) in resource.products" class="product-listing">
                                      <div v-if="product.picture"><img :src="product.picture + '/fit/100xauto'"/></div>
                                      <div>
                                        <span class="name">{{ product.name }}</span>
                                        <span class="sku">{{ product.sku }}</span>
                                        <br>
                                        <span>Déduction de stock par achat: <b style="font-weight:bold;">{{ product.stock_quantity_out }} pièce(s)</b></span>
                                      </div>
                                      <button @click="removeProduct(index)" class="bt-remove"><i class="icon icon-icon_close"></i></button>
                                    </div>
                                  </div>
                                </div>

                              </fieldset>

                              <fieldset>
                                <h3>Détails du stock</h3>
                                <p class="headline"></p>

                                <form-checklist v-model="shipping_state"
                                                :options="actionsSource"
                                                multiple="false"
                                                :callback="setShippingState"></form-checklist>

                                <div v-if="shipping_state == 'delay'" style="padding-left: 40px;">
                                  <form-datex label="Date de disponibilité" v-model="resource.available_at" :hide-time="true" time="00:00:00"></form-datex>

                                  <h3>Conditions de réapprovisionnement</h3>

                                  <div v-for="line in resource.conditions">
                                    <div>Si commandé entre <input type="text" v-model="line.time_min"/>h et <input type="text" v-model="line.time_max"/>h</div>
                                    <div>Livraison le jour ouvré + <input type="text" v-model="line.business_days"/> jour(s) à <input type="text" v-model="line.business_day_time"/>h</div>
                                    <button @click="removeCondition"><span>Supprimer</span></button>
                                  </div>

                                  <button @click="addCondition"><span>Ajouter une condition</span></button>

                                </div>

                              </fieldset>

                            </tab>
                            <tab name="Notifications">

                              <fieldset>
                                <h3>Alerte de stock</h3>
                                <p class="headline"></p>

                                <div class="form-field form-products">
                                  <form-toggle label="Absolute value" v-model="resource.stock_minimum_isvalue"></form-toggle>
                                </div>
                                <div class="form-field form-products" v-if="resource.stock_minimum_isvalue">
                                  <form-text label="Quantité minimum en stock" v-model="resource.stock_minimum_value"></form-text>
                                </div>
                                <div class="form-field form-products" v-else>
                                  <form-text label="Pourcentage" v-model="resource.stock_minimum_value"></form-text>
                                </div>

                              </fieldset>

                            </tab>
                        </tabs>
                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import InventoryService from './InventoryService.js';
    import ProductService from './../product/ProductService.js';
    import BranchService from '../../config/branch/BranchService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                resource:{
                },
                branches: null,
                product: null,
                productService: null,
                shipping_state: 'direct',
                actionsSource: [
                  {id:'direct', name:'Disponibilité immédiate', description: "La marchandise est en stock dans notre entrepôt"},
                  {id:'delay', name:'Disponibilité avec délai', description: "La marchandise comporte un délai d'approvisionnement"}
                ]
            }
        },
        mounted: function(){

            this.productService = ProductService;

            BranchService.query().then(response => {
                this.branches = response.data.data
                this.isLoading = false
            });

        },
        methods:{
            addCondition: function(){
              this.resource.conditions.push({
                time_min: 0,
                time_max: 10,
                business_days: 0,
                business_day_time: 10,
              });
              this.$forceUpdate();
            },
          removeCondition: function(index){
            this.resource.conditions.splice(index,1);
          },
            setShippingState: function(item){
              console.log('setShippingState', item)
              if( item && item.indexOf('direct') >= 0 )
              {
                this.resource.available_at = null;
                this.resource.shipping_delay = 0;
              }
            },
            resourceLoaded: function(){
                this.resource.products = this.resource.products || [];
                this.resource.conditions = this.resource.conditions || [];
                //this.setTranslations(['name','description','headline','meta_url','meta_title','meta_description']);


                this.shipping_state = this.resource.available_at || this.resource.conditions.length > 0 ? 'delay' : 'direct';

                this.initialize()
            },
            getResource: function(){
                return InventoryService
            },
            beforeUpdate: function(Resource){
                if( this.shipping_state == "direct" )
                {
                  Resource.available_at = null;
                  Resource.available_in = 0;
                }
                return true;
            },
            addProductToInventory: function(item){

                console.log(JSON.stringify(item),typeof item,  window._isEmpty(item));

                if( item && !window._isEmpty(item) ){
                    this.resource.products.push(this.product);
                    this.$forceUpdate()
                }
            },
            removeProduct: function(index){
                this.resource.products.splice(index, 1);
                this.$forceUpdate()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/inventory/Edit.vue